import { create } from 'zustand';

interface ResponsesPanelState {
  isOpen: boolean;
  questionId: string | null;
  selectedCategory: string | null;
  open: (questionId: string, categoryId?: string) => void;
  close: () => void;
  setCategory: (categoryId: string | null) => void;
}

const useResponsesPanelStore = create<ResponsesPanelState>((set) => ({
  isOpen: false,
  questionId: null,
  selectedCategory: null,
  open: (questionId: string, categoryId?: string) =>
    set({ isOpen: true, questionId, selectedCategory: categoryId ?? null }),
  close: () => set({ isOpen: false, questionId: null, selectedCategory: null }),
  setCategory: (categoryId: string | null) => set({ selectedCategory: categoryId }),
}));

export default useResponsesPanelStore;
